export function stripInlineFontSize(html: string): string {
  const input = html ?? "";
  if (!input.trim()) return input;

  try {
    const doc = new DOMParser().parseFromString(input, "text/html");

    // Remove any embedded styles that could set font sizes.
    for (const el of Array.from(doc.querySelectorAll("style"))) {
      el.remove();
    }

    // Remove `font-size` from inline style attributes.
    const styled = Array.from(doc.querySelectorAll<HTMLElement>("[style]"));
    for (const el of styled) {
      const style = el.getAttribute("style") ?? "";
      if (!style) continue;

      const keptDecls: string[] = [];
      for (const rawDecl of style.split(";")) {
        const decl = rawDecl.trim();
        if (!decl) continue;
        const [rawProp, ...rest] = decl.split(":");
        const prop = (rawProp ?? "").trim().toLowerCase();
        // `font` shorthand can encode font-size, so we strip it too.
        if (prop === "font-size" || prop === "font") continue;
        keptDecls.push(rest.length ? `${rawProp}:${rest.join(":")}`.trim() : decl);
      }

      const next = keptDecls.join("; ");

      if (next) {
        el.setAttribute("style", next);
      } else {
        el.removeAttribute("style");
      }
    }

    // Remove legacy `<font size="...">` attrs (keep tag; browser will ignore `size` once removed).
    const fonts = Array.from(doc.querySelectorAll<HTMLElement>("font[size]"));
    for (const el of fonts) el.removeAttribute("size");

    return doc.body.innerHTML;
  } catch {
    // If DOMParser fails for any reason, fall back to original.
    return input;
  }
}


